module.exports = __webpack_public_path__ + "media/images/application/icons/icon-upload-448c12e7dd063cd97565c7b70ebcb034.svg";